export default "__VITE_ASSET__BFU7SqRd__"